import { Observable } from 'rxjs';
import { ConnectionData } from '../providers/web-socket-connection.provider';

export interface WebsocketProvider {
  config: ConnectionData;

  disconnect(): void;
  listenForEvent<T = any>(channel: string, event: string, privateChannel: boolean): Observable<T>;
  listenGlobal<T = any>(channel: string, privateChannel: boolean): Observable<T>;
  initialize(): void;
  setConfig(connectionData: ConnectionData): void
}
